import { Link } from "react-router-dom";

// import logo from "/logo.png";
import shoppingcart from "../shoppingcart.png";
import addtocart from "../addtocart.png";
// import requisition from "./requisition.png";
// import invoice from "./invoice.png";
// import consumptionReport from "./consumptionreporticon.png";

const PurchaseDashboard = () => {
  return (
    <>
      <div class="content">
        <div class="container-fluid">
          <div class="row g-3">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">
                    <div className="col py-2">
                      <Link to="/purchaseStock" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Stock
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Stock value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={shoppingcart}
                                  alt="shoppingcart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/purchaseExpenditure"
                        className="text-decoration-none"
                        onClick={() => {
                          localStorage.setItem("selectedMenu", "reportAdd");
                        }}
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Expenditure
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Expenditure value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/purchasePO"
                        className="text-decoration-none"
                        onClick={() => {
                          localStorage.setItem("selectedMenu", "purchasePO");
                        }}
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Purchase Order
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  // src={invoice}
                                  src="https://cdn-icons-png.flaticon.com/512/11449/11449774.png"
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/purchasePO"
                        className="text-decoration-none"
                        onClick={() => {
                          localStorage.setItem("selectedMenu", "purchaseReport");
                        }}
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Consumption Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Requisition value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src="static/media/consumptionreporticon.c6816bd00f29c9ea6dbc.png"
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/purchaseExpenditure"
                        className="text-decoration-none"
                        onClick={() => {
                          localStorage.setItem("selectedMenu", "report");
                        }}
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Expenditure value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/receiptReport"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Receipt Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div className="display-2 fs-2 fw-normal font-sans-serif text-warning" id="totalState" >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/StockRegisterReport"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Stock Register Report
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div className="display-2 fs-2 fw-normal font-sans-serif text-warning" id="totalState" >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DashboardCard = ({ title, to, logo }) => (
  <Link to={to} style={{ textDecoration: "none" }}>
    <div className="col py-2">
      <div className="card overflow-hidden h-100" style={{ cursor: "pointer" }}>
        <div
          className="bg-holder bg-card"
          style={{ backgroundImage: "url(images/corner-7.png)" }}
        ></div>
        <div className="card-body position-relative">
          <h6 className="d-flex flex-between-center mono-card-text">{title}</h6>
          <div className="d-flex flex-between-center">
            <div>
              <div
                className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                id="totalState"
              >
                {/* Insert value here if needed */}
              </div>
            </div>
            <div>
              <img src={logo} className="" alt="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Link>
);
export default PurchaseDashboard;
